import { render, staticRenderFns } from "./ShebinPageDHL.vue?vue&type=template&id=1b11439e&scoped=true"
import script from "./ShebinPageDHL.vue?vue&type=script&lang=js"
export * from "./ShebinPageDHL.vue?vue&type=script&lang=js"
import style0 from "./ShebinPageDHL.vue?vue&type=style&index=0&id=1b11439e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b11439e",
  null
  
)

export default component.exports